export const BIOMETRY_DISPATCH_API = Object.freeze({
  UPLOAD_PHOTOS: 'biometry/uploadPhotos',
  UPLOAD_VIDEO: 'biometry/uploadVideo',
});
